<template>
  <div class="page">
    <div class="group">
      <div class="search">
        <img src="../../assets/new/Frame@2x.png" alt="" />
        <input type="text" placeholder="搜索您想要的关键词" class="search-input" v-model="selectValue" @keyup.enter="getData(true)" />
      </div>

      <!-- 数据列表 -->
      <div class="selectList">
        <div class="li" v-for="course in courselist" :key="course.id" @click="handleDetail(course)">
          <div class="left">
            <img :src="course.classImage" alt="铜仁学院省级专业技术人员继续教育培训平台" v-if="course.classImage !== null" />
            <img src="../../assets/new/xiaoBg.png" alt="铜仁学院省级专业技术人员继续教育培训平台" v-else />
          </div>
          <div class="right">
            <div class="text_1">{{ course.className || '' }}</div>
            <div class="text_2">
              <span class="tearch1">{{ course.classCredithour || 0 }}学时</span>
              <!-- <span class="money">￥{{ course.classPrice || 0 }}</span> -->
            </div>
            <div class="tearch">
              <span class="money" v-if="course.isClassApply == '02' || course.isClassApply == null"
                ><span style="font-weight: 500; color: red; font-size: 12px">￥</span>{{ Number(course.classPrice).toFixed(1) || 0 }}
              </span>
              <div class="money" v-if="course.isClassApply == '01'">
                <span style="font-weight: 500; color: red; font-size: 12px">￥</span>{{course.creditPrice || 0 }}
                <span style="font-size: 12px; font-weight: 500; color: red">/学时</span>
              </div>
              <div class="btn_7" v-if="course.isClassApply == '02' && course.isBuy == '02'" @click.stop="toWatch(course)">
                <img src="../../assets/new/bofang.png" alt="" /><span>播放</span>
              </div>
              <div class="btn" v-if=" course.classEnrolStatus == '02'&&course.isClassApply == '01'">
                <span class="bofang" @click.stop="toWatch2(course)"> 试看</span>
                <span class="pay" @click.stop="handleorder(course)"> 购买</span>
              </div>
              <div class="btn" v-if="course.isBuy == '01' && course.classEnrolStatus == '02'&&course.isClassApply == '02'">
                <span class="bofang" @click.stop="toWatch2(course)"> 试看</span>
                <span class="pay" @click.stop="handleorder(course)"> 购买</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 加载中的提示 -->
      <div v-if="isLoading" class="loading">数据正在加载中，请稍等...</div>
      <div class="load-more" v-if="hasMoreData && !isLoading">
        <div @click="loadMore" style="color: #999">点击加载更多</div>
      </div>
      <div class="no-more" v-if="hasMoreData1 && !isLoading">
        <div>没有更多数据了</div>
      </div>
    </div>
     <van-popup v-model="balanceShow" round>
      <div class="balanBox">
        <div class="b1">账户余额抵扣支付</div>

        <van-checkbox-group v-model="balanRadio" icon-size="16px" class="bn2" @change="onCheckboxChange">
          <van-cell-group class="bn2">
            <van-cell clickable @click="toggleCheck('1')" v-if="balance>0">
              <div>
                <div class="b2">账户余额支付 ¥{{ Number(classPrice).toFixed(2) }}</div>
                <div class="b3">剩余{{ balanZkNum.toFixed(2) < 0 ? 0 : balanZkNum.toFixed(2) }}元</div>
              </div>
              <template #right-icon>
                <van-checkbox name="1" ref="checkboxes" />
              </template>
            </van-cell>
            <van-cell clickable @click="toggleCheck('2')" v-if="surplusIntegral>0">
              <div>
                 <div class="b2">账户积分抵扣 ¥{{Math.min((surplusIntegral / 30),classPrice).toFixed(2)}}</div>
                <div class="b3"  v-if="this.balanRadio[0]=='2'">剩余积分抵扣金额{{ balanZkNum1.toFixed(2) < 0 ? 0 : balanZkNum1.toFixed(2) }}元</div>
                <div class="b3" v-else>剩余积分抵扣金额{{ (surplusIntegral/30).toFixed(2) }}元</div>
              </div>
              <template #right-icon>
                <van-checkbox name="2" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>

        <div class="btnBox">
          <div class="btn" style="background: #e4e4e4; color: #666666" @click="balanceShow = false">取消</div>
          <div class="btn" @click="toOrder">立即购买</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { toClassCenter } from '../../api/select';
import { toGeneratePxOrder, toTry } from '../../api/chooseClass';
import { toGenerateOrder } from '../../api/classDetail';
import { Dialog } from 'vant';
export default {
  data() {
    return {
      selectValue: '', // 输入框值
      pageSize: 10, // 每页显示条数
      pageNum: 1, // 当前页码
      courselist: [], // 课程列表
      isLoading: false, // 是否正在加载数据
      hasMoreData: false, // 是否还有更多数据
      hasMoreData1: false, // 是否没有更多数据
      balanceShow: false,
      balanRadio: [],
      surplusIntegral: 0, //积分
      balanZkNum1: 0, //折扣后剩下的积分

      balanZkNum: 0, //折扣后剩下的余额
      payFalg: false,
      balance: 0, //账户余额抵扣
      classPrice: ''
    };
  },
  created() {
    const historySearch = localStorage.getItem('historySearch');
    let keyword = '';
    if (historySearch) {
      try {
        const parsed = JSON.parse(historySearch);
        if (Array.isArray(parsed) && parsed.length > 0) {
          keyword = parsed[0]; // 取第一个值
        }
      } catch (e) {}
    }

    if (keyword) {
      this.selectValue = keyword;
      this.getData(true);
    }
  },
  mounted() {},
  methods: {
     toggleCheck(name) {
      if (this.balanRadio[0] === name) {
        this.balanRadio = [];
      } else {
        this.balanRadio = [name];
      }
      this.onCheckboxChange(this.balanRadio);
    },
    onCheckboxChange(value) {
      console.log('当前选中:', value);
    },
    //去播放
    toWatch(course) {
      if (course.isZYPX == '02') {
        this.$router.push({
          path: '/myClass',
          query: {
            name: 'b'
          }
        });
      } else {
        this.$router.push({
          path: '/myClass',
          query: {
            name: 'a'
          }
        });
      }
    },
    toWatch2(course) {
      toTry({ classId: course.id }).then(res => {
        if (res.data.code == 200) {
          this.$router.push({
            path: '/tryPlaying',
            query: { id: res.data.data.cwId, name: res.data.data.chapterTitle ,isZYPX:course.isZYPX}
          });
        } else if (res.data.code == 500) {
          this.$utils.showToast('该课程暂不支持试看');
        }
      });
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    //职业培训生成订单
    handleorder(course) {
      //02表示是职业培训课程
      // if (course.isZYPX == '02') {
      //   const data = {
      //     classId: course.id,
      //     courseIds: '',
      //     derateType: '',
      //     equipment: '02'
      //   };
      //   toGenerateOrder(data).then(res => {
      //     if (res.data.data.result == 0) {
      //       //创建订单失败返回信息
      //       this.$utils.showToast(res.data.data.msg);
      //       return false;
      //     }
      //     if (res.data.data.result == 1) {
      //       //余额小于金额，抵扣后跳转到收银台继续支付或没勾选账户抵扣跳收银台
      //       let data = res.data.data.order;
      //       this.$router.push({
      //         path: '/payType',
      //         query: data
      //       });
      //     }
      //     //已有订单
      //     if (res.data.data.result == 3) {
      //       this.balanceShow = false;
      //       Dialog.confirm({
      //         title: '温馨提示',
      //         message: res.data.data.msg,
      //         confirmButtonColor: '#2A70F2'
      //       })
      //         .then(() => {
      //           this.$router.push('/myOrder');
      //         })
      //         .catch(() => {
      //           // this.$utils.showToast('用户点击了取消');
      //         });
      //       return false;
      //     }
      //   });
      // } else {
        //非职业培训课程
        //非整体报名
        if (course.isClassApply == '01') {
          this.$router.push({
            path: '/classDetail',
            query: { classId: course.id }
          });
        } else {
          //整体报名
          //判断余额是否抵扣
          // if (this.balance !== 0 || this.surplusIntegral != 0) {
          //   this.classPrice = course.classPrice;
          //   this.balanceShow = true;
          //   this.classIds = course.id;
          //   this.balanZkNum = this.balance - course.classPrice;
          //   this.balanZkNum1 = (this.surplusIntegral / 30).toFixed(2) - course.classPrice;
          // } else {
            this.classIds = course.id;

            this.toOrder();
          // }
        // }
      }
    },
    //购买生成订单
    toOrder() {
      if (this.payFalg) {
        this.$utils.showToast('点击过快，请稍后再试！');
        return false;
      }
      let data = {
        classId: this.classIds,
                // derateType: this.balanRadio[0] == '1' ? '01' : this.balanRadio[0] == '2' ? '02' : '03', //判断是否勾选了抵扣
        courseIds: '',
        equipment: '02'
      };
      this.payFalg = true;
      setTimeout(() => {
        this.payFalg = false;
      }, 5000);
      toGenerateOrder(data).then(res => {
        this.payFalg = false;
        if (res.data.data.result == 0) {
          //创建订单失败返回信息
          this.$utils.showToast(res.data.data.msg);
          this.balanceShow = false;
          return false;
        }
        if (res.data.data.result == 1) {
          //余额小于金额，抵扣后跳转到收银台继续支付或没勾选账户抵扣跳收银台
          let data = res.data.data.order;
          this.$router.push({
            path: '/payType',
            query: data
          });
        }
        //余额大于金额，直接购买成功
        if (res.data.data.result == 2) {
          let data = res.data.data.order;
          this.$router.push({
            path: '/paySuccess',
            query: data
          });
        }
        //已有订单
        if (res.data.data.result == 3) {
          this.balanceShow = false;
          Dialog.confirm({
            title: '温馨提示',
            message: res.data.data.msg,
            confirmButtonColor: '#2A70F2'
          })
            .then(() => {
              this.$router.push('/myOrder');
            })
            .catch(() => {
              // this.$utils.showToast('用户点击了取消');
            });
          return false;
        }
      });
    },

    addSearchHistory(value) {
      // 获取本地存储的历史记录
      let searchHistory = localStorage.getItem('historySearch');
      let historyArray = searchHistory ? JSON.parse(searchHistory) : [];
      // 避免重复
      const index = historyArray.indexOf(value);
      if (index > -1) {
        historyArray.splice(index, 1);
      }
      historyArray.unshift(value);
      // 保留最多5条历史记录
      if (historyArray.length > 5) {
        historyArray = historyArray.slice(0, 5);
      }
      localStorage.setItem('historySearch', JSON.stringify(historyArray));
    },
    // 获取列表数据
    getData(reset = false) {
      if (reset) {
        this.pageNum = 1;
        this.courselist = [];
      }
      if (this.selectValue.trim()) {
        this.addSearchHistory(this.selectValue);
      }
      this.isLoading = true;
      const params = {
        searchText: this.selectValue,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        token: localStorage.getItem('token')
      };

      toClassCenter(params)
        .then(res => {
          const list = res.data.data.dataTable.rows || [];
          this.balance = res.data.data.balance;
          this.surplusIntegral = res.data.data.surplusIntegral;

          if (list.length < this.pageSize) {
            this.hasMoreData = false;
            this.hasMoreData1 = true;
          } else {
            this.hasMoreData = true;
            this.hasMoreData1 = false;
          }

          if (reset) {
            this.courselist = list;
          } else {
            this.courselist = [...this.courselist, ...res.data.data.dataTable.rows];
            if (this.pageNum * this.pageSize >= res.data.data.dataTable.total) {
              this.hasMoreData = false;
              this.hasMoreData1 = true;
            }
          }
        })
        .catch(err => {})
        .finally(() => {
          this.isLoading = false;
        });
    },

    // 加载更多数据
    loadMore() {
      this.pageNum += 1;
      this.getData(false);
    },
    // 点击详情跳转
    handleDetail(course) {
      //isZYPX   02 是职业培训   01 不是
      if (course.isZYPX == '01') {
        //购买了直接跳学习页面
        if (course.isClassApply == '02' && course.isBuy == '02') {
          this.$router.push({
            path: '/myClass',
            query: {
              name: 'a'
            }
          });
        } else {
          this.$router.push({
            path: '/classDetail',
            query: { classId: course.id }
          });
        }
      } else {
        if (course.isClassApply == '02' && course.isBuy == '02') {
          this.$router.push({
            path: '/myClass',
            query: {
              name: 'b'
            }
          });
        } else {
          this.$router.push({
            path: '/zyDetail',
            query: { classNo: course.id }
          });
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
.page {
  background-color: #fff;
  height: 100vh;
  // overflow-y: scroll;
}
.group {
  padding: 0 15px;
  background-color: #fff;

  overflow-y: scroll;
}
.title {
  display: flex;
  justify-content: space-between;
}
.title img {
  width: 18px;
  height: 18px;
}
.ti {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: #333333;
}
.search-input {
  border: 0;
  width: 100%;
  height: 42px;
  background: #f6f8fa;
  border-radius: 8px 8px 8px 8px;
  padding-left: 40px;
  font-size: 14px;
  color: #999;
}
.search {
  margin-top: 16px;
  position: relative;
  background-color: #fff;
  width: 100%;
  height: 40px;
}
.search-input::placeholder {
  color: #999;
}
.search img {
  width: 14px;
  height: 14px;
  position: absolute;
  top: 53%;
  left: 22px;
  transform: translateY(-50%);
}
.selectList {
  background: #fff;
  height: auto;
  margin-top: 10px;
  padding-bottom: 57px;
}
.li {
  width: 100%;
  height: 118px;
  background: #ffffff;
  padding: 24px 0px 0 0px;
  display: flex;
}
.li .left {
  border: 0;
  width: 110px;
  margin-right: 10px;
  height: 88px;
}
.li .left img {
  width: 110px;
  height: 88px;
  border-radius: 8px;
}
.text_1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-align: left;
  margin-top: 5px;
}
.tearch {
  height: 32px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tearch1 {
  font-family: PingFang SC, PingFang SC;
  font-size: 13px;
  color: #999999;
}
.money {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 17px;
  color: #ff2d31;
}
.right {
  width: 225px;
  display: flex;
  flex-direction: column;
}
.text_2 {
  display: flex;
  margin-top: 8px;
  justify-content: space-between;
}
.bofang {
  width: 50px;
  height: 32px;
  background: #f3f3f5;
  border-radius: 27px 0px 0px 27px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #2a70f2;
  text-align: center;
  line-height: 32px;
  display: inline-block;
}
.pay {
  display: inline-block;
  text-align: center;
  line-height: 32px;
  width: 50px;
  height: 32px;
  background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
  border-radius: 0px 27px 27px 0px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
}
.bofang img {
  width: 16px;
  height: 16px;
}
.load-more {
  text-align: center;
  margin-top: 10px;
  padding-bottom: 64px;
}

.no-more {
  text-align: center;
  font-size: 14px;
  color: #999;
  margin-top: 10px;
}

.loading {
  text-align: center;
  font-size: 14px;
  color: #999;
  /* margin-top: 20px; */
}
.btn_7 {
  width: 74px;
  height: 32px;
  background: #f3f3f5;
  border-radius: 27px 27px 27px 27px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #2a70f2;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
}
.balanBox {
  width: 300px;
  height: auto;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 22px 20px;
  .b1 {
    color: #333333;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
  }
  .bn2 {
    margin-top: 20px;
    width: 100% !important;
    background: #f6f8fa !important;
    border-radius: 8px 8px 8px 8px;
    .b2 {
      color: #333333;
      font-size: 14px;
    }
    .b3 {
      color: #999999;
      font-size: 12px;
    }
  }

  .btnBox {
    display: flex;
    justify-content: space-between;
    .btn {
      margin-top: 20px;
      width: 117px;
      height: 48px;
      background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
      border-radius: 8px 8px 8px 8px;
      text-align: center;
      line-height: 48px;
      font-size: 15px;
      color: #fff;
    }
  }
}
</style>
